import React, { Component } from 'react';
import { Button } from 'react-materialize';

import defaultImage from '../../images/EmptyPicture.png';
import './ImageViewer.css';

const ZOOM_DELTA = 5;
const MAX_ZOOM = 150;
const ROTATION_DELTA = 90;

class ImageViewer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      zoom: 25,
      rotation: 0
    };

    this.zoomOut = this.zoomOut.bind(this);
    this.zoomIn = this.zoomIn.bind(this);
    this.rotateLeft = this.rotateLeft.bind(this);
    this.rotateRight = this.rotateRight.bind(this);
  }

  get image() {
    return this.state.image;
  }

  set image(image) {
    this.setState({ image: image });
  }

  get zoom() {
    return this.state.zoom;
  }

  set zoom(zoom) {
    this.setState({ zoom: zoom });
  }

  get rotation() {
    return this.state.rotation;
  }

  set rotation(rotation) {
    this.setState({ rotation: rotation });
  }

  zoomOut() {
    const { zoom } = this.state;

    if (zoom <= ZOOM_DELTA) {
      return;
    }

    this.setState({ zoom: zoom - ZOOM_DELTA });
  }

  zoomIn() {
    const { zoom } = this.state;

    if (zoom >= MAX_ZOOM - ZOOM_DELTA) {
      return;
    }

    this.setState({ zoom: zoom + ZOOM_DELTA });
  }

  rotateLeft() {
    const { rotation } = this.state;

    this.setState({ rotation: rotation - ROTATION_DELTA });
  }

  rotateRight() {
    const { rotation } = this.state;

    this.setState({ rotation: rotation + ROTATION_DELTA });
  }

  render() {
    const { zoom, rotation } = this.state;
    const { image, hideToolbar } = this.props;

    return (
      <div className="image-viewer" >
        <div className="toolbar" style={ hideToolbar ? { display: 'none' } : {} }>
          <Button floating icon="zoom_out" waves='light' onClick={ this.zoomOut } />
          <Button floating icon="zoom_in" waves='light' onClick={ this.zoomIn } />
          <Button floating icon="rotate_left" waves='light' onClick={ this.rotateLeft } />
          <Button floating icon="rotate_right" waves='light' onClick={ this.rotateRight } />
        </div>
        <div className="canvas" style={ { backgroundSize: `${zoom}%`, transform: `rotate(${rotation}deg)`, backgroundImage: `url(${image ? image : defaultImage})` } }></div>
      </div>
    );
  }
}

export default ImageViewer;
